const riot = require('riot');

riot.tag2('page-slide', '<div class="slide-page"> <div class="slide-header f fm fbw px16 py12 flex-fixed"> <div class="f fm gap-8"> <div class="fs16 bold text-white">スライド</div> <div class="fs12 text-white opacity-70 lh15">{currentPage} / {totalPages}</div> </div> <div class="f fm gap-12"><a class="f fm text-white opacity-70 cursor-pointer text-decoration-none" href="/{note.path}" if="{note}"><i class="icon-arrow-left fs16 mr4"></i><span class="fs13">ノートに戻る</span></a><i class="icon-close fs24 text-white opacity-70 cursor-pointer" onclick="{goBack}"></i></div> </div> <div class="slide-body relative flex-auto f fh overflow-hidden" ref="slideBody"> <div class="f fh" show="{isLoading}"> <div data-is="atom-loading"></div> </div> <div class="slide-container f fh" ref="slideContainer" show="{!isLoading}"> <div class="slide-content" ref="slideContent"></div> </div> </div> <div class="slide-nav f fm flex-between px16 py12 flex-fixed"> <button class="slide-nav-button f fh px16 py8 rounded-8 cursor-pointer" onclick="{prevSlide}" disabled="{currentPage &lt;= 1}"><i class="icon-arrow-left fs16 mr4"></i><span class="fs13">前へ</span></button> <div class="f fm gap-4"> <div class="slide-dot cursor-pointer {active: i === currentPage - 1}" each="{page, i in pages}" onclick="{() =&gt; goToSlide(i + 1)}"></div> </div> <button class="slide-nav-button f fh px16 py8 rounded-8 cursor-pointer" onclick="{nextSlide}" disabled="{currentPage &gt;= totalPages}"><span class="fs13">次へ</span><i class="icon-arrow-right fs16 ml4"></i></button> </div> </div>', 'page-slide,[data-is="page-slide"]{display:block;position:fixed;top:0;left:0;right:0;bottom:0;z-index:999999} page-slide .slide-page,[data-is="page-slide"] .slide-page{width:100%;height:100%;display:flex;flex-direction:column;background:#1a1a2e} page-slide .slide-header,[data-is="page-slide"] .slide-header{background:rgba(0,0,0,0.3)} page-slide .slide-body,[data-is="page-slide"] .slide-body{flex:1;min-height:0} page-slide .slide-container,[data-is="page-slide"] .slide-container{width:100%;height:100%;padding:24px 48px} page-slide .slide-content,[data-is="page-slide"] .slide-content{width:100%;height:100%;background:#fff;border-radius:8px;box-shadow:0 4px 24px rgba(0,0,0,0.3);overflow:auto;padding:48px 64px} page-slide .slide-content .katex-mathml,[data-is="page-slide"] .slide-content .katex-mathml{position:absolute;clip:rect(1px, 1px, 1px, 1px);padding:0;border:0;height:1px;width:1px;overflow:hidden} page-slide .slide-content section,[data-is="page-slide"] .slide-content section{display:none} page-slide .slide-content section.active,[data-is="page-slide"] .slide-content section.active{display:block} page-slide .slide-content section.title,[data-is="page-slide"] .slide-content section.title{text-align:center} page-slide .slide-content section.title.active,[data-is="page-slide"] .slide-content section.title.active{display:flex;flex-direction:column;align-items:center;justify-content:center;min-height:100%} page-slide .slide-content section h1,[data-is="page-slide"] .slide-content section h1{font-size:42px;font-weight:bold;margin-bottom:24px;line-height:1.3} page-slide .slide-content section h2,[data-is="page-slide"] .slide-content section h2{font-size:32px;font-weight:bold;margin-bottom:20px;line-height:1.3} page-slide .slide-content section h3,[data-is="page-slide"] .slide-content section h3{font-size:22px;font-weight:bold;margin-bottom:16px;line-height:1.3} page-slide .slide-content section p,[data-is="page-slide"] .slide-content section p{font-size:18px;line-height:1.8;margin-bottom:12px} page-slide .slide-content section ul,[data-is="page-slide"] .slide-content section ul,page-slide .slide-content section ol,[data-is="page-slide"] .slide-content section ol{font-size:18px;line-height:1.8;margin-bottom:12px;padding-left:28px} page-slide .slide-content section li,[data-is="page-slide"] .slide-content section li{margin-bottom:8px} page-slide .slide-content section li input[type="checkbox"],[data-is="page-slide"] .slide-content section li input[type="checkbox"]{display:none} page-slide .slide-content section li input[type="checkbox"]+span::before,[data-is="page-slide"] .slide-content section li input[type="checkbox"]+span::before{content:\'⬜\';margin-right:6px;font-size:1.1em} page-slide .slide-content section li input[type="checkbox"]:checked+span::before,[data-is="page-slide"] .slide-content section li input[type="checkbox"]:checked+span::before{content:\'✅\'} page-slide .slide-content section code,[data-is="page-slide"] .slide-content section code{background:#f0f0f0;padding:2px 6px;border-radius:4px;font-size:16px} page-slide .slide-content section pre,[data-is="page-slide"] .slide-content section pre{background:#1e1e1e;color:#d4d4d4;padding:16px 20px;border-radius:8px;overflow-x:auto;margin-bottom:16px} page-slide .slide-content section pre code,[data-is="page-slide"] .slide-content section pre code{background:none;padding:0} page-slide .slide-content section img,[data-is="page-slide"] .slide-content section img{max-width:60%;max-height:60vh;object-fit:contain;border-radius:4px;border:1px solid #e0e0e0} page-slide .slide-content section img.emoji,[data-is="page-slide"] .slide-content section img.emoji{width:18px;height:18px;vertical-align:-2px;border:none} page-slide .slide-content section table,[data-is="page-slide"] .slide-content section table{width:100%;border-collapse:collapse;margin-bottom:16px;font-size:16px} page-slide .slide-content section table th,[data-is="page-slide"] .slide-content section table th,page-slide .slide-content section table td,[data-is="page-slide"] .slide-content section table td{border:1px solid #ddd;padding:10px 14px;text-align:left} page-slide .slide-content section table th,[data-is="page-slide"] .slide-content section table th{background:#f5f5f5;font-weight:bold} page-slide .slide-content section a,[data-is="page-slide"] .slide-content section a{color:#4af} page-slide .slide-content section a:hover,[data-is="page-slide"] .slide-content section a:hover{text-decoration:underline currentColor} page-slide .slide-content section blockquote,[data-is="page-slide"] .slide-content section blockquote{border-left:4px solid var(--project-color, #4466ea);padding:8px 16px;margin:0 0 16px;color:#555;font-size:17px} page-slide .slide-nav,[data-is="page-slide"] .slide-nav{background:rgba(0,0,0,0.3)} page-slide .slide-nav-button,[data-is="page-slide"] .slide-nav-button{color:#fff;background:rgba(255,255,255,0.1);border:1px solid rgba(255,255,255,0.2);transition:background-color 150ms} page-slide .slide-nav-button:hover:not(:disabled),[data-is="page-slide"] .slide-nav-button:hover:not(:disabled){background:rgba(255,255,255,0.2)} page-slide .slide-nav-button:disabled,[data-is="page-slide"] .slide-nav-button:disabled{opacity:.3;cursor:default} page-slide .slide-dot,[data-is="page-slide"] .slide-dot{width:8px;height:8px;border-radius:50%;background:rgba(255,255,255,0.3);transition:all .2s} page-slide .slide-dot.active,[data-is="page-slide"] .slide-dot.active{background:#fff;transform:scale(1.3)}@media (max-width:768px){ page-slide .slide-container,[data-is="page-slide"] .slide-container{padding:12px 16px} page-slide .slide-content,[data-is="page-slide"] .slide-content{padding:24px 28px} page-slide .slide-content section h1,[data-is="page-slide"] .slide-content section h1{font-size:24px} page-slide .slide-content section h2,[data-is="page-slide"] .slide-content section h2{font-size:20px} page-slide .slide-content section h3,[data-is="page-slide"] .slide-content section h3{font-size:18px} page-slide .slide-content section p,[data-is="page-slide"] .slide-content section p,page-slide .slide-content section ul,[data-is="page-slide"] .slide-content section ul,page-slide .slide-content section ol,[data-is="page-slide"] .slide-content section ol{font-size:16px}}', '', function(opts) {
    this.currentPage = 1;
    this.totalPages = 1;
    this.pages = [];
    this.isLoading = true;

    this.head = () => {
      if (this.note) {
        return {
          title: `「${this.note.getTitle()}」スライド | ${spat.config.head.ogp.site_name}`,
        };
      }
    };

    this.preload = ({req, res}) => {
      return {
        workspace_id: req.params.workspace_id,
        project_id: req.params.project_id,
        note_id: req.params.note_id,
      };
    };

    this.loadMarp = () => {
      if (window.Marp) return Promise.resolve();
      return new Promise((resolve, reject) => {
        let fn = new Function('return ' + 'import("https://esm.sh/@marp-team/marp-core")');
        fn().then((mod) => {
          window.Marp = mod.Marp;
          resolve();
        }).catch(reject);
      });
    };

    this.on('show', async ({req, res}) => {
      this.isLoading = true;
      this.update();

      try {
        await app.store.setup(req.params);

        this.note = app.store.doc(`workspaces/${this.workspace_id}/projects/${this.project_id}/notes/${this.note_id}`);
        await this.note.fetch({cache: false, relation: true});

        let project = await this.note.getProject().fetch();
        document.documentElement.style.setProperty('--project-color', project?.getColor() || '#4466ea');

        await this.loadMarp();

        this.renderSlides();
        this.bindKeys();
      } catch (e) {
        console.error(e);
      } finally {
        this.isLoading = false;
        this.update();
      }
    });

    this.on('hide', () => {
      this.unbindKeys();
      if (this._marpStyle) {
        this._marpStyle.remove();
      }

      let darkTheme = document.getElementById('hljs-dark-theme');
      if (darkTheme) darkTheme.remove();
    });

    this.renderSlides = () => {

      let params = new URLSearchParams(location.search);
      let initialPage = parseInt(params.get('page'), 10) || 1;
      this.currentPage = 1;
      const content = this.note.data.content || '';

      const marp = new window.Marp({
        html: false,
        math: 'katex',
      });
      const { html, css } = marp.render(content);

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const sections = doc.querySelectorAll('section');

      if (sections.length === 0) {
        this.refs.slideContent.innerHTML = '<section class="active">' + doc.body.innerHTML + '</section>';
        this.totalPages = 1;
      } else {
        let slidesHtml = '';
        sections.forEach((section, i) => {
          let classes = section.className || '';
          classes += i === 0 ? ' active' : '';
          slidesHtml += '<section class="' + classes.trim() + '">' + section.innerHTML + '</section>';
        });
        this.refs.slideContent.innerHTML = slidesHtml;
        this.totalPages = sections.length;
      }

      this._marpStyle = document.createElement('style');
      this._marpStyle.textContent = css;
      this.refs.slideContent.prepend(this._marpStyle);

      if (!document.getElementById('katex-css')) {
        let katexLink = document.createElement('link');
        katexLink.id = 'katex-css';
        katexLink.rel = 'stylesheet';
        katexLink.href = 'https://cdnjs.cloudflare.com/ajax/libs/KaTeX/0.16.9/katex.min.css';
        document.head.appendChild(katexLink);
      }

      if (!document.getElementById('hljs-dark-theme')) {
        let link = document.createElement('link');
        link.id = 'hljs-dark-theme';
        link.rel = 'stylesheet';
        link.href = 'https://cdnjs.cloudflare.com/ajax/libs/highlight.js/11.5.0/styles/github-dark.min.css';
        document.head.appendChild(link);
      }

      this.pages = Array.from({ length: this.totalPages });

      this.refs.slideContent.querySelectorAll('pre code').forEach(block => {
        if (typeof hljs !== 'undefined') {
          hljs.highlightElement(block);
        }
      });

      if (initialPage > 1 && initialPage <= this.totalPages) {
        this.showSlide(initialPage);
      }

      this.refs.slideContent.querySelectorAll('li').forEach(li => {
        let text = li.innerHTML;
        if (text.startsWith('[x] ') || text.startsWith('[X] ')) {
          li.innerHTML = '<input type="checkbox" checked disabled><span>' + text.slice(4) + '</span>';
          li.style.listStyle = 'none';
        } else if (text.startsWith('[ ] ')) {
          li.innerHTML = '<input type="checkbox" disabled><span>' + text.slice(4) + '</span>';
          li.style.listStyle = 'none';
        }
      });

      this.refs.slideContent.querySelectorAll('a').forEach(a => {
        a.setAttribute('target', '_blank');
        a.setAttribute('rel', 'noopener noreferrer');
      });

      this.update();
    };

    this.showSlide = (page) => {
      const slides = this.refs.slideContent.querySelectorAll('section');
      slides.forEach((slide, i) => {
        slide.classList.toggle('active', i === page - 1);
      });
      this.currentPage = page;
      let url = new URL(location.href);
      url.searchParams.set('page', page);
      spat.router.replaceState(url);
      this.update();
    };

    this.prevSlide = () => {
      if (this.currentPage > 1) {
        this.showSlide(this.currentPage - 1);
      }
    };

    this.nextSlide = () => {
      if (this.currentPage < this.totalPages) {
        this.showSlide(this.currentPage + 1);
      }
    };

    this.goToSlide = (page) => {
      this.showSlide(page);
    };

    this.goBack = () => {
      history.back();
    };

    this.onKeyDown = (e) => {
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown' || e.key === ' ') {
        e.preventDefault();
        this.nextSlide();
      } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        e.preventDefault();
        this.prevSlide();
      } else if (e.key === 'Escape') {
        e.preventDefault();
        this.goBack();
      }
    };

    this.bindKeys = () => {
      document.addEventListener('keydown', this.onKeyDown);
    };

    this.unbindKeys = () => {
      document.removeEventListener('keydown', this.onKeyDown);
    };
});